import React, { Fragment } from "react";

import Page from "../../components/Page";
import ShiftTypeList from "../../components/ShiftTypeList";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";

const ShiftTypePage = () => (
  <Page title="Dienstsoorten">
    <Fragment>
      <CenteredPageContentContainer>
        <PaperContainer title="Dienstsoorten">
          <ShiftTypeList />
        </PaperContainer>
      </CenteredPageContentContainer>
      <Fab
        variant="circular"
        color="primary"
        style={{ position: "fixed", bottom: 40, right: 40 }}
        onClick={() => {
          window.location.href = `/shifttype/create`;
        }}
      >
        <AddIcon />
      </Fab>
    </Fragment>
  </Page>
);

export default ShiftTypePage;



// WEBPACK FOOTER //
// ./src/pages/ShiftType/ShiftTypePage.js